import React, { useState, useCallback, useRef, useEffect } from "react";
import Styles from "./SearchBarStyles.module.css";
import { AutoComplete, Input } from "antd";
import { ReactComponent as SearchButtonIcon } from "./../../Icons/searchButton.svg";
import { ReactComponent as SearchFilterIcon } from "./../../Icons/searchFilter.svg";
import { ReactComponent as UploadQIcon } from "./../../Icons/uploadQ.svg";
import { ReactComponent as CrossIcon } from "./../../Icons/cross.svg";
import { fetchAutosuggestions } from "../../API/api";
import { useSelector, useDispatch } from "react-redux";
import { replacepercentageSymbol } from "../../utils";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import debounce from "lodash.debounce";
import { CURRENT_ROLE } from "../../API/url";

export default function SearchBar() {
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);

  const [text, setText] = useState(searchState.inputValue);
  const [suggestions, setOptions] = useState([]);
  const [acHeight, setAcHeight] = useState();

  const inputRef = useRef(null);
  const searchBarRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!searchBarRef.current) return;

    const ele = searchBarRef.current;

    const update = () => {
      const h = ele.getBoundingClientRect().height;
      if (h) setAcHeight(h);
    };

    update();

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(ele);

    return () => resizeObserver.disconnect();
  }, []);

  const {
    searchInputValue,
    getkeyTagPayload,
    advanceFilterModalToggle,
    isExternalSearchAllowed,
  } = bindActionCreators(Actions, dispatch);

  const filterOptions = (arr) =>
    arr.map((ar, ind) => ({
      value: ar.question,
      key: ind + 1,
    }));

  const onSearchText = (value) => {
    if (value.trim().length > 4) {
      fetchAutosuggestions(value).then((res) => {
        if (res === undefined) return;
        setOptions([...filterOptions(res)]);
      });
    }
  };

  const debouncedFetchOptions = useCallback(
    debounce((value) => onSearchText(value), 500),
    []
  );

  const onChangeText = (e) => {
    setText(e);
    searchInputValue(e);
    setOptions([]);
    debouncedFetchOptions(e);
  };

  const onSubmit = (val, type) => {
    isExternalSearchAllowed(false);
    getkeyTagPayload(null);
    setOptions([]);
    if (text.trim().length < 4) return;

    navigate(
      `${Home_PAGE_URL}search/${encodeURIComponent(
        replacepercentageSymbol(val)
      )}/${type}`
    );
  };

  const filterOption = (inputValue, option) => option.value;

  return (
    <>
      <AutoComplete
        popupMatchSelectWidth={"100%"}
        style={{
          width: "100%",
          height: acHeight,
          marginBottom: suggestions?.length ? "5.5rem" : "1.0rem",
          paddingBottom: "0px",
        }}
        dropdownAlign={{ offset: [0, 0] }}
        popupClassName={Styles.searchSuggestionCss}
        options={suggestions}
        filterOption={filterOption}
        onSelect={(e) => onSubmit(e, true)}
        onChange={(e) => onChangeText(e)}
        size="large"
        onBlur={() => setOptions([])}
      >
        <div className={Styles.searchBar} ref={searchBarRef}>
          <div className={Styles.inputWrapper}>
            <Input.TextArea
              autoComplete="off"
              id="inputID"
              size="large"
              ref={inputRef}
              value={searchState.inputValue}
              type="text"
              placeholder="Ask your question"
              autoSize={{ minRows: 1, maxRows: 6 }}
              style={{
                border: "none",
                color: "#5C667B",
                fontSize: "18px",
                fontWeight: "400",
                textAlign: "justify",
              }}
              onPressEnter={() => onSubmit(text, false)}
            />
          </div>

          <div className={Styles.buttonsWrapper}>
            <div className={Styles.iconRow}>
              {CURRENT_ROLE === "Seeker" && (
                <div
                  className={Styles.svgIcon}
                  onClick={() =>
                    advanceFilterModalToggle({
                      bool: true,
                      value: "rfpMultiQ",
                    })
                  }
                >
                  <UploadQIcon />
                </div>
              )}
              <div
                className={Styles.svgIcon}
                onClick={() =>
                  advanceFilterModalToggle({
                    bool: true,
                    value: "advanceFilter",
                  })
                }
              >
                <SearchFilterIcon />
              </div>
            </div>

            <div className={Styles.buttonRow}>
              {searchState.inputValue.trim().length !== 0 && (
                <div
                  className={Styles.svgIcon}
                  onMouseDown={() => setOptions([])}
                  onClick={() => searchInputValue("")}
                >
                  <CrossIcon />
                </div>
              )}

              <SearchButtonIcon
                style={{
                  opacity: `${text.trim().length < 4 ? ".4" : "1"}`,
                  marginTop: "2px",
                  cursor: `${
                    text.trim().length < 4 ? "not-allowed" : "pointer"
                  }`,
                }}
                onMouseDown={() => setOptions([])}
                onClick={() => onSubmit(text, false)}
              />
            </div>
          </div>
        </div>
      </AutoComplete>

      {userState.brandingText &&
        CURRENT_ROLE === "Seeker" &&
        userState.brandingText.length !== 0 && (
          <div
            className={Styles.brandingText}
            style={{
              color: "#5C667B",
              padding: "6px",
            }}
            dangerouslySetInnerHTML={{ __html: userState.brandingText }}
          ></div>
        )}

      {CURRENT_ROLE === "Expert" && (
        <div
          style={{
            color: "#5C667B",
            padding: "10px",
            fontSize: "16px",
          }}
        >
          &nbsp;
          <span
            onClick={() => navigate(`${Home_PAGE_URL}createqapair`)}
            style={{ cursor: "pointer" }}
          >
            <i className="fa fa-plus"></i>&nbsp;Create a new knowledge base
            entry
          </span>
        </div>
      )}
    </>
  );
}
